import React from 'react'
import { css } from 'aphrodite'

import style from '../style'

import Menu from './Menu'

export const Toolbar = props => (
  <Menu className={css(style.toolbar.toolbar)}>{props.children}</Menu>
)

export default Toolbar



// WEBPACK FOOTER //
// ./src/components/partials/Editor/partials/Toolbar.js